import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { useReducedMotion } from "@/components/Cinematic";
import { ASSETS } from "@/lib/assets";

export default function Layout() {
  const reduced = useReducedMotion();
  const loc = useLocation();

  useEffect(() => {
    if (reduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, [reduced]);

  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);

  return (
    <div className="grain min-h-screen bg-[#F7F1E1]" style={{ "--paper-url": `url(${ASSETS.paper})` }}>
      <Nav />
      <main className="relative z-10 page-surface">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
